module.exports = __webpack_public_path__ + "img/banner2_9_zh.99781128.png";